import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";

export default class ActivateLockButton extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    isDetailed: PropTypes.bool.isRequired,
    showSpinner: PropTypes.func.isRequired, // (?string) => void
    hideSpinner: PropTypes.func.isRequired, // () => void
  };

  render() {
    const { model, isDetailed, showSpinner, hideSpinner } = this.props;
    const isActivatable = model.get("isActivatable");

    return (
      <CommonControlWrapper isDetailed={isDetailed}>
        <DeviceControlButton
          buttonLabel="Activate"
          disabled={!isActivatable}
          onTap={() => {
            showSpinner(`Activating '${model.get("name")}'`);
            model.activate().then(hideSpinner, hideSpinner);
          }}
        />
      </CommonControlWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/ActivateLockButton.jsx